import { MessageSquare } from 'lucide-react'

import { EntityManageSection } from '@/components/ui/entity-manage-section'
import { Button } from '@/components/ui/button'
import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'

export const RUBRIC_ASK_AGENT_PROMPT =
  'Draft focus areas for this rubric and validate them before I publish.'

type RubricAskAgentSectionProps = {
  highlighted?: boolean
  onAskAgent?: (message: string) => void
}

export function RubricAskAgentSection({
  highlighted,
  onAskAgent,
}: RubricAskAgentSectionProps) {
  return (
    <div id={rubricSectionHighlight('describe')}>
      <EntityManageSection
        title="Ask the agent"
        subtitle="Draft and validate criteria in chat — then publish from here"
        leadingIcon={MessageSquare}
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('describe')}
      >
        <div className="space-y-3 text-sm">
          <p className="text-muted-foreground">
            The left chat agent can propose focus areas and other criteria via{' '}
            <code className="text-xs">manage_rubrics</code> (draft → validate → publish). Edit names,
            weights, and levels on this page; use the agent when you want AI help.
          </p>
          {onAskAgent ? (
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() => onAskAgent(RUBRIC_ASK_AGENT_PROMPT)}
            >
              Ask the agent to draft focus areas
            </Button>
          ) : (
            <p className="text-xs text-muted-foreground">
              Open the agent chat and ask it to draft or validate criteria for this rubric.
            </p>
          )}
        </div>
      </EntityManageSection>
    </div>
  )
}
